import { QuoteDto } from 'src/dtos';
import { Quote } from 'src/models';

export const mapQuoteDtoToModel = (dto: QuoteDto): Quote => ({
  id: dto.symbol,
  last: dto.pricedata.last,
  change: dto.pricedata.changepercent,
  description: dto.longname,
  symbol: dto.symbol,
});

export const mapQuoteDtoListToModel = (dtosList: QuoteDto[]): Quote[] => dtosList.map(mapQuoteDtoToModel);
